// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-block-container {
    position: relative;
    margin-top: 20px;
}

.add-block-btn {
    width: 100%;
    padding: 15px;
    border: 2px dashed #007bff;
    background: transparent;
    color: #007bff;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.add-block-btn:hover {
    background: #007bff;
    color: white;
    border-style: solid;
}

.add-block-btn .mdi {
    font-size: 20px;
}

.block-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 1000;
    margin-top: 10px;
}

.block-options-header {
    padding: 15px;
    border-bottom: 1px solid #eee;
    background: #f8f9fa;
    border-radius: 8px 8px 0 0;
}

.block-options-header h4 {
    margin: 0;
    font-size: 16px;
    color: #333;
}

.block-options-list {
    padding: 10px;
}

.block-option {
    padding: 12px 15px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 5px;
}

.block-option:hover {
    background: #f8f9fa;
}

.block-option:last-child {
    margin-bottom: 0;
}

.block-option .mdi {
    font-size: 18px;
    color: #007bff;
    width: 24px;
    text-align: center;
}

.block-option span:last-child {
    font-size: 14px;
    color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/Components/HomePage/AddBlockButton/AddBlockButton.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf","sourcesContent":[".add-block-container {\n    position: relative;\n    margin-top: 20px;\n}\n\n.add-block-btn {\n    width: 100%;\n    padding: 15px;\n    border: 2px dashed #007bff;\n    background: transparent;\n    color: #007bff;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.add-block-btn:hover {\n    background: #007bff;\n    color: white;\n    border-style: solid;\n}\n\n.add-block-btn .mdi {\n    font-size: 20px;\n}\n\n.block-options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: white;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n    z-index: 1000;\n    margin-top: 10px;\n}\n\n.block-options-header {\n    padding: 15px;\n    border-bottom: 1px solid #eee;\n    background: #f8f9fa;\n    border-radius: 8px 8px 0 0;\n}\n\n.block-options-header h4 {\n    margin: 0;\n    font-size: 16px;\n    color: #333;\n}\n\n.block-options-list {\n    padding: 10px;\n}\n\n.block-option {\n    padding: 12px 15px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 5px;\n}\n\n.block-option:hover {\n    background: #f8f9fa;\n}\n\n.block-option:last-child {\n    margin-bottom: 0;\n}\n\n.block-option .mdi {\n    font-size: 18px;\n    color: #007bff;\n    width: 24px;\n    text-align: center;\n}\n\n.block-option span:last-child {\n    font-size: 14px;\n    color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
